import { Users } from '@/db/users';
const userDB = new Users();

import { Decks } from '@/db/decks';
const decksDB = new Decks();

import { Learning } from '@/db/learning';
const learnDB = new Learning();

import { Cards } from '@/db/cards';
const cardsDB = new Cards();

import { DueDateStats } from '@/db/dueDateStats';
const dueDateStatsDB = new DueDateStats();

import { Subscriptions } from '@/db/subscriptions';
const subDB = new Subscriptions();

import { Usage } from '@/db/usage';
const usageDB = new Usage();

import { Licensing } from '@/db/license';
const licensingDB = new Licensing();

import { Feedback } from '@/db/feedback';
const feedbackDB = new Feedback();

import { Timestamp } from '@/db/firestore';
import { firestore } from 'firebase';

export class Repository {
    public now = Timestamp.now();
    public users = userDB;
    public decks = decksDB;
    public learning = learnDB;
    public cards = cardsDB;
    public dueDateStats = dueDateStatsDB;
    public subscriptions = subDB;
    public usage = usageDB;
    public licensing = licensingDB;
    public feedback = feedbackDB;

    public toDate(ts: firestore.Timestamp) {
        if (ts) return ts.toDate();
        return null;
    }
}
